import { render, staticRenderFns } from "./AddPropertyComponent.vue?vue&type=template&id=9edc7076&"
import script from "./AddPropertyComponent.vue?vue&type=script&lang=js&"
export * from "./AddPropertyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports